import React, { useState } from "react";
import BaseApiCall from "../../api/BaseApiCall";

const NewOrg = () => {
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        cellNumber: '',
        remarks: ''
    });

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) {
            newErrors.name = 'Name is required';
        } else if (formData.name.length > 100) {
            newErrors.name = 'Name must be 100 characters or fewer!';
        } else if (formData.name.length < 5) {
            newErrors.name = 'Name must be 5 characters!';
        }

        const cellNumber = formData.cellNumber.replace(/[^0-9]/g, '');
        if (!cellNumber) {
            newErrors.cellNumber = 'Cell number is required';
        } else if (!/^01[0-9]{9}$/.test(cellNumber)) {
            newErrors.cellNumber = 'Invalid format for mobile number';
        }
        return newErrors;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
          return;
        }
        setErrors({});

        try {
            const response = await BaseApiCall.post('/settings/set', formData);
        } catch (error) {
            console.error('Error submitting form:', error);
            setPopupTitle("ERROR!")
            setPopupMessage("Error submitting the form. Please try again.");
            setShowPopup(true);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "cellNumber") {
            // Allow only numbers
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData((prev) => ({ ...prev, [name]: numericValue }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const closePopup = () => setShowPopup(false);
    
    return(
        <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">New Organization</h2>
            {errors.default && <p className="text-red-500 text-sm mt-1">{errors.default}</p>}
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Name</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        maxLength="100"
                        className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                    />
                    {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                </div>
                {/* Cell Number Field */}
                <div>
                    <label className="block text-sm font-medium text-gray-700">Cell Number</label>
                    <input
                        type="text"
                        name="cellNumber"
                        value={formData.cellNumber}
                        onChange={handleChange}
                        placeholder="+8801XXXXXXXXX"
                        className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                    />
                    {errors.cellNumber && (
                        <p className="text-red-500 text-sm mt-1">{errors.cellNumber}</p>
                    )}
                </div>

                {/* Remarks Field */}
                <div>
                    <label className="block text-sm font-medium text-gray-700">Remarks</label>
                    <textarea
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                        className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                    />
                </div>

                {/* Submit Button */}
                <button type="submit" className="px-6 py-2 text-white bg-teal-600 rounded-md hover:bg-teal-700">
                    Submit
                </button>
            </form>
            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 shadow-lg max-w-sm w-full">
                        <h3 className="text-lg font-semibold mb-2 text-gray-800">{popupTitle}</h3>
                        <p className="text-gray-700 mb-4">{popupMessage}</p>
                        <button
                            onClick={closePopup}
                            className="px-4 py-2 text-white bg-teal-600 rounded-md hover:bg-teal-700"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
export default NewOrg;